import { activeBoards } from "./activeBoards";
import { handleClassrooms } from "./handleClassrooms";
import { refreshBoards } from "./refreshBoards";
export function initalizeControlPanel() {
    document.querySelector(".cp-bulletin-board-settings").innerHTML = `
        <p style="margin-top: 0;">Use the available settings below to configure the bulletin board on the fly.</p>
        <section id="active-pages" class="cp-section">
            <h3>Active bulletin boards</h3>
            <p>Here is a list of the currently active bulletin boards in use right now.</p>
            <div class="cp-active__content"></div>
        </section>
        <section class="cp-section cp-edit-urls">
            <h3>Edit active URL</h3>
            <p>Select an active bulletin board, and update its URL with any needed configurations.</p>
            <form class="cp-edit-urls__form"></form>
        </section>
        <section class="cp-section">
            <h3>Refresh bulletin boards</h3>
            <p>The refresh button below will refresh any page that is actively running.</p>
            <p class="cp-refresh__controls">
                <button id="refresh" class="cp-refresh__btn cp__btn">Refresh</button>
                <span class="cp-refresh__status" id="refresh-status">&nbsp;</span>
            </p>
        </section>
        <section class="cp-section cp-classrooms">
            <h3>Bible class map</h3>
            <p>Use the below to manage the classroom locations and topics.</p>
            <div class="cp-active__content">
                <ul class="cp-classrooms__list">
                loading classrooms...
                </ul>
            </div>
        </section>
    `;
    refreshBoards();
    activeBoards();
    handleClassrooms();
}
